import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-times-bold",
  "use": "foquz-icon-times-bold-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-times-bold\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.453 6.831L3.81 5.189a.942.942 0 010-1.33.942.942 0 011.33 0L6.784 5.5l1.724-1.724a1.122 1.122 0 011.601 0 1.122 1.122 0 010 1.602L8.384 7.102l1.643 1.643a.942.942 0 010 1.33.942.942 0 01-1.33 0L7.054 8.433l-1.723 1.723a1.123 1.123 0 01-1.602 0 1.122 1.122 0 010-1.601L5.453 6.83z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol